import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from 'src/app/core/user/user.service';
import { MatDialog } from '@angular/material/dialog';
import { UserModalComponent } from './user-modal/user-modal.component';
import { ChangePasswordModalComponent } from './change-password-modal/change-password-modal.component';
import { User } from 'src/app/core/user';

@Component({
  selector: 'app-admin-panel',
  templateUrl: './admin-panel.component.html',
  styleUrls: ['./admin-panel.component.scss'],
})
export class AdminPanelComponent implements OnInit {
  displayedColumns: string[] = [
    'username',
    'name',
    'email',
    'role',
    'status',
    'pricePerBoardErect',
    'pricePerBoardChange',
    'actions',
  ];
  dataSource: MatTableDataSource<User>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private userService: UserService, public dialog: MatDialog) {}

  ngOnInit(): void {
    this.fetchUsers();
  }

  fetchUsers() {
    this.userService.fetchUsers({ limit: 1000 }).subscribe((response: any) => {
      this.dataSource = new MatTableDataSource(response.items);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openCreateUserModal() {
    const dialogRef = this.dialog.open(UserModalComponent, {
      width: '600px',
      data: { isEdit: false },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fetchUsers();
      }
    });
  }

  openEditUserModal(user: User) {
    const dialogRef = this.dialog.open(UserModalComponent, {
      width: '600px',
      data: { isEdit: true, user: user },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fetchUsers();
      }
    });
  }

  openChangePasswordModal(user: User) {
    const dialogRef = this.dialog.open(ChangePasswordModalComponent, {
      width: '400px',
      data: { userId: user.id },
    });

    dialogRef.afterClosed().subscribe(result => {
      //
    });
  }
}
